import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";

import {
    addRequestQueueItem,
    normalizeRequestQueueTail,
    upsertSaleOrderUpdateRequestQueueItem,
} from "@/store/slices/offline";

export const requestQueueTailListener = createListenerMiddleware();

requestQueueTailListener.startListening({
    matcher: isAnyOf(
        addRequestQueueItem,
        upsertSaleOrderUpdateRequestQueueItem,
    ),
    effect: async (action, api) => {
        if (action.type === normalizeRequestQueueTail.type) return;

        api.dispatch(normalizeRequestQueueTail());
    },
});
